export const JOURNEY_STEP_DELAY = 6000;

export function attachJourneyAutoplay(root, advance, { paused = false, control, onMotionChange = () => {} } = {}) {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  onMotionChange(motion.matches);
  if (!window.IntersectionObserver) return () => {};

  let visible = false;
  let hovering = window.matchMedia('(hover: hover)').matches && root.matches(':hover');
  let timer;
  const clear = () => window.clearTimeout(timer);
  const schedule = () => {
    clear();
    const focused = root.contains(document.activeElement) && document.activeElement !== control?.current;
    if (paused || !visible || hovering || focused || document.hidden || motion.matches) return;
    timer = window.setTimeout(() => { advance(); schedule(); }, JOURNEY_STEP_DELAY);
  };
  const enter = event => {
    if (event.pointerType === 'mouse' || event.pointerType === 'pen') { hovering = true; schedule(); }
  };
  const leave = () => { hovering = false; schedule(); };
  const blur = event => {
    // focusout fires before activeElement moves to its next target.
    clear();
    if (!root.contains(event.relatedTarget) || event.relatedTarget === control?.current) {
      timer = window.setTimeout(schedule, 0);
    }
  };
  const motionChange = () => { onMotionChange(motion.matches); schedule(); };
  const observer = new IntersectionObserver(([entry]) => {
    visible = entry.isIntersecting && entry.intersectionRatio >= 0.2;
    schedule();
  }, { threshold: 0.2, rootMargin: '-100px 0px -40px' });

  observer.observe(root);
  root.addEventListener('pointerenter', enter);
  root.addEventListener('pointerleave', leave);
  root.addEventListener('focusin', schedule);
  root.addEventListener('focusout', blur);
  root.addEventListener('click', schedule);
  document.addEventListener('visibilitychange', schedule);
  motion.addEventListener('change', motionChange);
  return () => {
    clear();
    observer.disconnect();
    root.removeEventListener('pointerenter', enter);
    root.removeEventListener('pointerleave', leave);
    root.removeEventListener('focusin', schedule);
    root.removeEventListener('focusout', blur);
    root.removeEventListener('click', schedule);
    document.removeEventListener('visibilitychange', schedule);
    motion.removeEventListener('change', motionChange);
  };
}
